import { Folder } from './folder-group/types'

export interface FolderProject {
  id: string
  title: string
  showAddButton: boolean
  hrefPrefix: string
  items: Folder[]
}

// Mock folder projects
export const FOLDER_PROJECTS: FolderProject[] = [
  {
    id: 'projects',
    title: 'Project',
    showAddButton: true,
    hrefPrefix: '/workspace',
    items: [
      {
        id: 'workspace-projects',
        name: 'Untitled Project 01',
        href: '/workspace/projects',
        canDelete: true,
        canRename: true,
        isDraggable: true,
      },
    ],
  },
  /* {
    id: "private",
    title: "Private",
    showAddButton: true,
    hrefPrefix: "/workspace/private",
    items: [
      {
        id: "private-all",
        name: "All",
        href: "/workspace/private",
        canDelete: false,
        canRename: false,
        isDraggable: false,
      },
      {
        id: "private-projects",
        name: "Projects",
        href: "/workspace/private/projects",
        canDelete: true,
        canRename: true,
        isDraggable: true,
      },
      {
        id: "private-trash",
        name: "Trash",
        href: "/workspace/trash",
        canDelete: false,
        canRename: false,
        isDraggable: false,
      },
    ],
  }, */
]
